import React from 'react'
import { LogoIcon } from '~/shared/ui/icons'

type Props = {
  logoWidth?: number
  color?: string
  sx?: React.CSSProperties
}

export function Logo({ logoWidth = 160, sx, color }: Props) {
  return (
    <div style={sx}>
      <div style={{ maxWidth: logoWidth }}>
        <LogoIcon color={color} />
      </div>
    </div>
  )
}
